import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useSearchParams } from 'react-router-dom'; // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
// import { useDispatch } from 'react-redux'; // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
// import { setUser } from '../../features/auth/authSlice'; // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
// import storageManager from '../../utils/storageManager'; // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
// import api from '../../services/api'; // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch(); // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
  // const [searchParams] = useSearchParams(); // COMMENTED OUT - UNCOMMENT WHEN VERIFICATION IS ENABLED
  const [status, setStatus] = useState('success'); // TEMPORARY: Changed to 'success' for testing
  const [message, setMessage] = useState('Your registration and subscription payment has been completed successfully!');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // TODO: UNCOMMENT VERIFICATION LOGIC WHEN BACKEND IS READY
    // For now, just show success message and redirect to signup

    // Start countdown and redirect to signup
    let counter = 5;
    const interval = setInterval(() => {
      counter--;
      setCountdown(counter);
      if (counter === 0) {
        clearInterval(interval);
        navigate('/auth/login');
      }
    }, 1000);

    return () => clearInterval(interval);

    /* ============================================
       COMMENT OUT VERIFICATION LOGIC (UNCOMMENT WHEN BACKEND READY)
       ============================================

    if (!sessionId) {
      setStatus('failed');
      setMessage('Invalid payment session. Please try again.');
      return;
    }

    // Verify payment and complete registration
    const verifyPayment = async () => {
      try {
        // Poll for payment status (max 10 attempts, 2 seconds apart)
        let attempts = 0;
        const maxAttempts = 10;

        const checkStatus = async () => {
          try {
            const response = await api.get(`/auth/verify-payment/${sessionId}`, {
              params: { provider }
            });

            if (response.data.success && response.data.user) {
              // Payment verified and user created
              const { user, token } = response.data;

              // Store auth data
              storageManager.setToken(token);
              storageManager.setUser(user);
              dispatch(setUser(user));

              setStatus('success');
              setMessage('Your registration and subscription payment has been completed successfully!');

              // Start countdown
              let counter = 5;
              const interval = setInterval(() => {
                counter--;
                setCountdown(counter);
                if (counter === 0) {
                  clearInterval(interval);
                  // Redirect to appropriate dashboard
                  if (user.role === 'coach') {
                    navigate('/coach/dashboard');
                  } else if (user.role === 'scout') {
                    navigate('/scout/dashboard');
                  } else {
                    navigate('/');
                  }
                }
              }, 1000);

              return true;
            } else if (response.data.status === 'processing') {
              // Still processing, continue polling
              return false;
            } else {
              // Payment failed or expired
              throw new Error(response.data.message || 'Payment verification failed');
            }
          } catch (error) {
            if (attempts < maxAttempts - 1) {
              // Continue polling
              return false;
            } else {
              // Max attempts reached
              throw error;
            }
          }
        };

        // Poll until success or max attempts
        while (attempts < maxAttempts) {
          const success = await checkStatus();
          if (success) break;

          attempts++;
          if (attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }

        if (attempts >= maxAttempts && status !== 'success') {
          throw new Error('Payment verification timeout. Please contact support.');
        }

      } catch (error) {
        console.error('Payment verification error:', error);
        setStatus('failed');
        setMessage(error.response?.data?.message || error.message || 'Payment verification failed. Please contact support.');
      }
    };

    verifyPayment();
    ============================================ */
  }, [navigate]); // searchParams and dispatch removed from dependencies while verification is disabled

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="max-w-2xl w-full text-center">
          {status === 'verifying' && (
            <>
              <div className="mb-8">
                <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-cyan-400"></div>
              </div>
              <h1 className="text-4xl font-anton text-white mb-4">
                VERIFYING PAYMENT
              </h1>
              <p className="text-gray-300 font-roboto text-lg mb-8">
                {message}
              </p>
              <p className="text-gray-400 font-roboto text-sm">
                Please wait while we confirm your payment with the payment provider...
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="mb-8">
                <svg
                  className="w-20 h-20 text-green-400 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h1 className="text-4xl font-anton text-white mb-4">
                REGISTRATION SUCCESSFUL!
              </h1>
              <p className="text-gray-300 font-roboto text-lg mb-4">
                {message}
              </p>
              <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-8 max-w-lg mx-auto">
                <p className="text-white font-roboto text-base mb-2">
                  Please log in with your email and password to access your account.
                </p>
                <p className="text-gray-400 font-roboto text-sm">
                  You will be redirected to the login page automatically.
                </p>
              </div>
              <p className="text-cyan-400 font-roboto text-xl font-bold">
                Redirecting to login in {countdown} seconds...
              </p>
            </>
          )}

          {status === 'failed' && (
            <>
              <div className="mb-8">
                <svg
                  className="w-20 h-20 text-red-400 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h1 className="text-4xl font-anton text-white mb-4">
                PAYMENT VERIFICATION FAILED
              </h1>
              <p className="text-gray-300 font-roboto text-lg mb-8">
                {message}
              </p>
              <div className="space-y-4">
                <button
                  onClick={() => navigate('/auth/signup')}
                  className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-anton text-lg rounded-xl transition-colors"
                >
                  TRY AGAIN
                </button>
                <p className="text-gray-400 font-roboto text-sm">
                  If you were charged but registration failed, please contact support with your payment details.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccessPage;
